import { ReactElement } from 'react'
import { WorkOrderRevisionRequest } from '~/api/work_order'

export enum BulkFileUploadStatusType {
  NO_STATUS = 'no_status',
  SUCCESS = 'success',
  ERROR = 'error',
  IN_PROGRESS = 'in_progress'
}
export type FileUploadProps = {
  currentStep: number
  handleShowTimeline: (modelName: string, step: number) => void
  clearIsFileUpload: () => void
}

export type FileUploadState = {
  bulkUploadFile: File
  selectedFields: string[]
  selectedSowPaymentType: number
  requiredApprovals: boolean
  disableConnectors: boolean
  reasonForUpdate: string
  bulkUpdateRecordId?: number
  previewResults: PreviewResult[]
  filterQuery?: any
}

export type SOWFileUploadState = Omit<FileUploadState, 'disableConnectors'> & {
  sowPaymentType: number
  reasonId?: number
  reasonComments?: string
}

export type CSVColumnType = {
  columnName: string
  isRequired?: boolean
  ignoreIfNone?: boolean
  strip?: boolean
  mappers?: Array<(value: string) => string | number>
}

export type GenericCSVField = {
  key: string
  value: string | unknown | number
}
export type GenericCSVRow = GenericCSVField[]

export type BulkFileWorkOrderResponse = {
  status: BulkFileUploadStatusType
  message?: string
  component?: ReactElement
}

export type WorkOrderPreview = {
  workOrderId: string
  request?: WorkOrderRevisionRequest
  response?: BulkFileWorkOrderResponse
  revisionKey?: string
}

export type PreviewResult = {
  name: string
}
export type SOWBulkStoreForFileUpload = Omit<BulkStoreForFileUpload, 'fileUploadState' | 'actions'> & {
  fileUploadState: SOWFileUploadState
  actions: Omit<BulkStoreForFileUpload['actions'], 'updateActions'> & {
    updateActions: {
      updateFileUploadState: (uploadState: Partial<SOWFileUploadState>) => void
    }
  }
}

export type BulkStoreForFileUpload = {
  model: { id: string; name: string }
  shouldShowRequiresApprovalField: boolean | null
  shouldShowSOWSkipApprovalsField: boolean | null
  shouldShowDisableConnectorsField: boolean | null
  actions: {
    steps: {
      increment: () => void
      decrement: () => void
      setCurrentStep: (step: number) => void
    }
    updateActions: {
      updateFileUploadState: (uploadState: Partial<FileUploadState>) => void
    }
  }
  fileUploadState: FileUploadState
  previewResults: PreviewResult[]
  currentStep: number
  isWorkdayEnabled: boolean
}

export type PreviewError = {
  body?:
    | {
        [key: string]: Array<{ string?: string } | string> | string[] | any[]
      }
    | {
        message?: string | string[]
      }
    | Record<string, any>
  message?: string
}

export type PreviewErrorResponse = {
  body?: {
    message?: string
  }
}

// Work Order Specific Consts
export const WORK_ORDER_SPREADSHEET_PRIMARY_KEY = 'work_order_id'
